import React, { useEffect, useState } from "react";

const SparklingBackground = () => {
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    const sparkleCount = 50; // Adjust number of sparkles
    const newSparkles = Array.from({ length: sparkleCount }).map((_, i) => ({
      id: i,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      animationDuration: `${Math.random() * 3 + 2}s`,
      animationDelay: `${Math.random() * 2}s`,
    }));
    setSparkles(newSparkles);
  }, []);

  return (
    <div className="sparkling-background">
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="sparkle"
          style={{
            top: sparkle.top,
            left: sparkle.left,
            animationDuration: sparkle.animationDuration,
            animationDelay: sparkle.animationDelay,
          }}
        />
      ))}
    </div>
  );
};

export default SparklingBackground;
